import { render, staticRenderFns } from "./easyPaisaBeneficiaryComponent.vue?vue&type=template&id=a1a63e92&"
import script from "./easyPaisaBeneficiaryComponent.vue?vue&type=script&lang=js&"
export * from "./easyPaisaBeneficiaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports